var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{name: 'assistenza-searchitem'}}},[_c('span',{staticClass:"text-decoration-none ghd-text-white ghd-ITCAvant"},[_vm._v("APRI PRATICA ASSISTENZA")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }